import React from 'react';
import isNil from 'lodash/isNil';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  DEFAULT_EMPTY_VALUE,
} from 'core/constants';
import MatchedAuthorizationIndicators from 'pages/Dashboard/pages/Billing/ClaimForm/AuthorizationSelector/components/MatchedAuthorizationIndicators';
import type {
  AuthorizationValueProps,
} from 'pages/Dashboard/pages/Billing/ClaimForm/AuthorizationSelector/types';
import {
  findExactOption,
} from 'pages/Dashboard/pages/Billing/ClaimForm/AuthorizationSelector/utils';

export default function AuthorizationValue({
  selection,
  options,
}: AuthorizationValueProps) {
  const option = findExactOption(options, selection?.authorizationNumber);
  const authorizationNumber = selection?.authorizationNumber;

  return (
    <span className="inline-flex min-w-0 max-w-full items-center gap-1">
      <span className="min-w-0 truncate">
        {notEmptyString(authorizationNumber) ? authorizationNumber : DEFAULT_EMPTY_VALUE}
      </span>
      {!isNil(option) && (
        <MatchedAuthorizationIndicators option={option} showMatchDot />
      )}
    </span>
  );
}
